import { useState } from 'react';

// Custom hook for geolocation
const useGeolocation = () => {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);

  // Don't automatically request location on mount
  // Location will be requested only when explicitly needed

  const requestLocation = async () => {
    if (!navigator.geolocation) {
      const errorMsg = 'Geolocation ist in diesem Browser nicht verfügbar. Bitte verwenden Sie einen modernen Browser oder geben Sie die Position manuell ein.';
      setError(errorMsg);
      return Promise.reject(errorMsg);
    }

    // Check if we're on HTTPS (required for geolocation in production)
    // Allow HTTP for localhost, container environments, and development
    if (window.location.protocol !== 'https:' && 
        !window.location.hostname.includes('localhost') && 
        !window.location.hostname.includes('127.0.0.1') &&
        !window.location.hostname.includes('agent-env') &&
        window.location.hostname !== '0.0.0.0') {
      const errorMsg = 'Geolocation erfordert eine sichere Verbindung (HTTPS).';
      setError(errorMsg);
      return Promise.reject(errorMsg);
    }

    const options = {
      enableHighAccuracy: true,
      timeout: 15000, // Increased timeout
      maximumAge: 30000 // Reduced max age
    };

    try {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, options);
      });
      
      const locationData = {
        id: crypto.randomUUID(), // CRITICAL: UUID for stable geo-identification
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy
      };
      
      console.log('GPS location obtained:', locationData);
      setLocation(locationData);
      setError(null);
      return locationData;
      
    } catch (err) {
      console.error('Geolocation error:', err);
      
      let errorMessage = '';
      switch(err.code) {
        case 1: // PERMISSION_DENIED
          errorMessage = 'Standortzugriff wurde verweigert. Bitte erlauben Sie den Standortzugriff in den Browser-Einstellungen und laden Sie die Seite neu.';
          break;
        case 2: // POSITION_UNAVAILABLE
          errorMessage = 'Standortinformationen sind nicht verfügbar. GPS-Signal ist möglicherweise zu schwach.';
          break;
        case 3: // TIMEOUT
          errorMessage = 'Standortabfrage ist abgelaufen. Versuchen Sie es erneut oder verwenden Sie die manuelle Eingabe.';
          break;
        default:
          errorMessage = err.message || 'Unbekannter GPS-Fehler aufgetreten.';
          break;
      }
      
      setError(errorMessage);
      throw new Error(errorMessage);
    }
  };

  return { location, error, requestLocation };
};

export default useGeolocation;
